import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import {  Image,  StyleSheet, Text, View } from 'react-native';
import splash from './assets/slider-box-opt.gif'
import React, {useState, useEffect} from 'react';
import Welcome from './Components/Welcome';
import Questions from './Components/Questions';
import Answers1 from './Components/Answer1';
import Signup from './Components/Signup';
import Signup1 from './Components/Signup1';
import UserDetails from './Components/UserDetails';
import Login from './Components/Login';
import Diagnostic from './Components/Diagnostic';
import ForgotPassword from './Components/ForgotPassword';
import AsyncStorage from '@react-native-async-storage/async-storage';
 



const Stack = createNativeStackNavigator();

function SplashScreen({navigation}) {

    const [isLoading, setLoading] = useState(true);
    let [token, setToken] = useState('');
    let [error, setError] = useState('');
    const GetTokenFromApi = async  () => {
      try {
        const response = await fetch('https://rupertapi.azurewebsites.net/api/authorize', {
          method:'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(
            {
              "appToken": "559d8cd3076ffdf871c82d8acb3baa9bb56224c2be2b66bd9233caee99f63b61",
              "appSecret": "6f779c5d9361afdf553bc9de0abf27019956afe9391ccbbc0e1eaeeb7fea3be5",
            }
          )
        }
        )
        const json = await response.json();
        console.log();
        setToken(json.token);
        setLoading(true);
        setTimeout(() => {
          navigation.replace('Acasa',
          {
            tokenKey:json.token
          });
        }, 500);
      } catch (error) {
        console.error(error);
        setError('Autentificarea nu functioneaza! Posibil sa nu fii conectat la internet. Te rog sa verifici conexiunea la internet, si sa incerci din nou. Daca problema persista inseamna ca avem noi o problema la servere. Vom remedia problema in cel mai scurt timp!');
        setLoading(false);
      } finally {
        //setLoading(false);
      }
    }

    const [Nume, setNume] = useState();
    const [preNume, setpreNume] = useState();
    let [notFound, setnotFound] = useState(false);
    const SearchNameUtilizator = async  (storageToken,storagePUN_utilizatorID) => {
      try {
      const response = await fetch('https://rupertapi.azurewebsites.net/api/utilizator/'+storagePUN_utilizatorID, {
          method:'GET',
          headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '+storageToken
          }
        }
        )
        const json = await response.json();
        console.log(json);
        if (json !== null) {
          setTimeout(() => {
            navigation.replace('Acasa',
            {
              tokenKey:storageToken,
              PUN_utilizatorID:storagePUN_utilizatorID,
              Nume:json.nume,
              preNume:json.preNume,
              notFound:false
            });
          }, 100);
        } else {
            //get general token if not found
            try {
            const response = await fetch('https://rupertapi.azurewebsites.net/api/authorize', {
              method:'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(
                {
                  "appToken": "559d8cd3076ffdf871c82d8acb3baa9bb56224c2be2b66bd9233caee99f63b61",
                  "appSecret": "6f779c5d9361afdf553bc9de0abf27019956afe9391ccbbc0e1eaeeb7fea3be5",
                }
              )
            }
            )
            const json = await response.json();
            console.log();
            setToken(json.token);
            setLoading(true);
            setTimeout(() => {
              navigation.replace('Acasa',
              {
                tokenKey:json.token,
                // PUN_utilizatorID:storagePUN_utilizatorID,
                // Nume:'Te rog să te loghezi din nou',
                // preNume:'folosind emailul și parola ta!',
                notFound:false
              });
            }, 500);
          } catch (error) {
            console.error(error);
            setError('Autentificarea nu functioneaza! Posibil sa nu fii conectat la internet. Te rog sa verifici conexiunea la internet, si sa incerci din nou. Daca problema persista inseamna ca avem noi o problema la servere. Vom remedia problema in cel mai scurt timp!');
            setLoading(false);
          } finally {
            //setLoading(false);
          }
        }
        } catch (error) {
        console.error(error);
        setnotFound(true);
        //get general token if not found
          try {
            const response = await fetch('https://rupertapi.azurewebsites.net/api/authorize', {
              method:'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(
                {
                  "appToken": "559d8cd3076ffdf871c82d8acb3baa9bb56224c2be2b66bd9233caee99f63b61",
                  "appSecret": "6f779c5d9361afdf553bc9de0abf27019956afe9391ccbbc0e1eaeeb7fea3be5",
                }
              )
            }
            )
            const json = await response.json();
            console.log();
            setToken(json.token);
            setLoading(true);
            setTimeout(() => {
              navigation.replace('Acasa',
              {
                tokenKey:json.token,
                PUN_utilizatorID:storagePUN_utilizatorID,
                Nume:'Te rog să te loghezi din nou',
                preNume:'folosind emailul și parola ta!',
                notFound:true
              });
            }, 500);
          } catch (error) {
            console.error(error);
            setError('Autentificarea nu functioneaza! Posibil sa nu fii conectat la internet. Te rog sa verifici conexiunea la internet, si sa incerci din nou. Daca problema persista inseamna ca avem noi o problema la servere. Vom remedia problema in cel mai scurt timp!');
            setLoading(false);
          } finally {
            //setLoading(false);
          }
        } finally {
          //setLoading(false);
      }
    };


    let [storageToken, setstorageToken]  = useState('');
    let [storagePUN_utilizatorID, setstoragePUN_utilizatorID]  = useState('');
    const getData = async () => {
      try {
        const storageToken = await AsyncStorage.getItem('@token');
        const utilizatorID = await AsyncStorage.getItem('@UtilizatorID');
        const storagePUN_utilizatorID = JSON.parse(utilizatorID); //JSON.parse(utilizatorID); "\"\\\"11476\\\"\""
        setstorageToken(storageToken);
        setstoragePUN_utilizatorID(storagePUN_utilizatorID);
        if(storageToken !== null && (storagePUN_utilizatorID !== null || storagePUN_utilizatorID !== undefined )) 
        {
          SearchNameUtilizator(storageToken,storagePUN_utilizatorID);
        } else {
        GetTokenFromApi();
      }
      } catch(e) {
        // error reading value
      }
    }

  useEffect(() => {
    getData();
    setLoading(true);
  }, []);
  // console.log('token:'+token);
  // console.log('isLoading: '+isLoading);
  // console.log('storageToken: '+storageToken);
  // console.log('storagePUN_utilizatorID: '+storagePUN_utilizatorID);
  // console.log('Nume:'+Nume);
  // console.log('preNume:'+preNume);
  // console.log('notFound:'+notFound);

  return (
    <View style={styles.container}>
      {isLoading ? (
      <Image style={styles.SplashGif} source={splash}></Image>
      ) : (  
        <Text style={styles.MainText}>Ups... ceva nu e in regula!{"\n"}{error}</Text>
      )}
    </View>
  );
}


export default function App() {

  return (
    <NavigationContainer>
      <Stack.Navigator initialRouteName="Rupertbot se incarca">
        <Stack.Screen name="Rupertbot se incarca" component={SplashScreen} />
        <Stack.Screen name="Acasa" component={Welcome} />
        <Stack.Screen name="Intrebari" component={Questions} />
        <Stack.Screen name="Evaluare Nouă" component={Answers1} />
        <Stack.Screen name="Inregistrare" component={Signup} />
        <Stack.Screen name="Inregistrare..." component={Signup1} />
        <Stack.Screen name='Diagnostic' component={Diagnostic} />
        <Stack.Screen name="Contul meu" component={UserDetails} />
        <Stack.Screen name="Login" component={Login} />
        <Stack.Screen name="Resetare Parola" component={ForgotPassword} />
      </Stack.Navigator>
    </NavigationContainer>
  );
}



const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logo: {
    position: "absolute",
    top: 30,
    left: 20,
    width: 300, 
    height: 99
  },
  h1: {
    fontSize: 25,
    position: "absolute",
    top: 130,
    color:"#628914"
  },
  MainText: {
    fontSize: 20,
    color: "#3E473A",
    flexShrink: 1,
    padding: 50

  },
  Question: {
    fontSize: 30,
    fontWeight: 'bold',
    color: "#628914",
    flexShrink: 1,
    position:"absolute",
    top:350,
  },
  QuestionImage: {
    width:270,
    height:200,
    position:'absolute', 
    top:400
  },
  SplashGif: {
    width:400,
    height:400,
    position:'absolute', 
    flex:1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },

});